// AddHelpNumber.js

import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import UserClasses from '../users/Users.module.css';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import CategoryClasses from '../categories/AddCategory.module.css';
import { Services } from 'Services';
import { useNavigate } from 'react-router-dom';
import { Success, Error } from 'Util/Toast';
import { Button } from '@mui/material';
import CommonTutorClasses from '../commoncssfiles/CategoryTutor.module.css';
import ProductClasses from '../products/Products.module.css';

const AddHelpNumber = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);

    // Handle form submission
    const onSubmit = async (data) => {
        setLoading(true);

        const requestBody = {
            helpNumber: data.HelpNumber,  // Adjusted field name
        };

        const token = { Authorization: `token ${localStorage.getItem('Token')}` };

        try {
            const response = await Services.addOrUpdateHelpNumber(requestBody, token);  // Adjusted service call
            if (response.Status === 1) {
                navigate('/helpnumber');  // Adjusted route if needed
                Success('Help number added successfully!');
            } else {
                console.error('Error adding help number:', response.Message);
                Error(response.Message);
            }
        } catch (error) {
            console.error('Error adding help number:', error);
            Error('An error occurred while adding the help number.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout Active={'HelpNumber'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Create Help Number</title>
            </Helmet>
            <div className={UserClasses['main-first-container']}>
                <div className={UserClasses['main-data-tab']}>
                    <div className={UserClasses['add-users-btn']}>
                        <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                            BACK
                        </Button>
                    </div>
                    <div className={CommonTutorClasses['wrapper']} data-aos="zoom-in-down">
                        <h2 className={CommonTutorClasses['main-header']}>Create Help Number</h2>
                        <form style={{ display: 'block' }} className={CommonTutorClasses["form"]} onSubmit={handleSubmit(onSubmit)}>
                            <div style={{ marginBottom: '10px' }} className={CommonTutorClasses['form-control']}>
                                <label htmlFor="HelpNumber">Help Number</label>
                                <input
                                    type='text'
                                    {...register('HelpNumber', {
                                        required: 'Help number is required',
                                        pattern: {
                                            value: /^[0-9]{10}$/,
                                            message: 'Help number must be a 10-digit number'
                                        }
                                    })}
                                    style={{ width: '97%' }}
                                />
                                {errors.HelpNumber && <p className={CategoryClasses["error-text"]}>{errors.HelpNumber.message}</p>}
                            </div>
                            <div className={ProductClasses['form-btn-main']}>
                                <Button style={{ marginTop: '10px' }} type="submit" disabled={loading}>
                                    {loading ? 'Adding...' : 'Add Help Number'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AddHelpNumber;
